export default {
  companies: null,
  metadata: null,
  allCompanyList: [],
  currentSpecializations: null,
  specializations: null,
  currentSettings: null,
  settings: null,
  employeeLimit: null,
  tests360Settings: null,
  statusesImportEmployees: null,
  recordTypes: null,

  portfolio: null,
  organizers: null,
  managers: null,
  employees: null,
  employeesCount: null,
  employeesTotalCount: null,
  employeesComponentName: null,
  links: null,
  roadmaps: null,
  subEmployees: null,
  subEmployeesFilters: {
    supervisorName: null,
    employeeName: null,
  },
  banEmployees: null,
  employeeFilters: {
    teamIds: [],
    employeeId: null,
    employeeName: null,
    organizerName: null,
    specializationIds: [],
    teamSpecIds: [],
  },

  metadataTests360: null,
  metadataSelfTests: null,
  metadataPersonalTests: null,
  metadataBHPersonalTests: null,
  availableBHPersonalTests: null,
  enabledPersonalTests: null,

  teams: null,
  allTeams: null,
  managedTeams: null,
  teamsTree: null,
  teamGroupsFlat: null,
  teamGroups: null,
  teamGroup: null,

  tests360: [],
  personal: [],
  license: [],
  adaptation: [],

  targets: null,
  allTargets: null,
  archivalTargets: null,
  curators: null,

  isLoading: false,
  isEmployeeLimitLoading: false,
  companyListLoading: false,
  checkTeamTests360Loading: false,

  isSubmitting: false,
  errors: null,
  validationErrors: null,
};
